// ═══════════════════════════════════════════════════════════════════
//  CourrielDossiers.js
//  Onglets de dossiers : Reçus, Envoyés, Indésirables, Corbeille — extrait de Courriel
// ═══════════════════════════════════════════════════════════════════

import { THEME } from "../../socle/theme";
import { DOSSIERS_ORDRE, ICONES_DOSSIERS, LIBELLES_DOSSIERS } from "./constantes";

export function CourrielDossiers({ dossier, dossiers, setDossier, setFiltre, setRecherche }) {
  return (
    <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 14 }}>
    {DOSSIERS_ORDRE.map((cle) => {
      const info = dossiers.find((d) => d.key === cle);
      const actif = dossier === cle;
      const absent = dossiers.length > 0 && !info;
      return (
        <button key={cle} onClick={() => { setDossier(cle); setFiltre(""); setRecherche(""); }}
          disabled={absent}
          title={absent ? "Ce dossier n'existe pas sur le serveur" : undefined}
          style={{
            background: actif ? THEME.accentDim : THEME.surface,
            border: `1px solid ${actif ? THEME.accent : THEME.border}`,
            color: absent ? THEME.textDim : (actif ? "#9CC2FF" : THEME.textMuted),
            borderRadius: 10, padding: "8px 15px", fontSize: 13, fontWeight: 700,
            cursor: absent ? "not-allowed" : "pointer", fontFamily: "inherit",
            opacity: absent ? .45 : 1, display: "flex", alignItems: "center", gap: 7,
          }}>
          <span>{ICONES_DOSSIERS[cle]}</span>
          {LIBELLES_DOSSIERS[cle]}
          {info?.unread > 0 && (
            <span style={{ background: THEME.accent, color: "#fff", fontSize: 10, fontWeight: 800,
                           borderRadius: 999, padding: "1px 7px" }}>{info.unread}</span>
          )}
          {info && info.unread === 0 && info.total > 0 && (
            <span style={{ color: THEME.textDim, fontSize: 11 }}>{info.total}</span>
          )}
        </button>
      );
    })}
  </div>
  );
}
